import type { ReactNode } from 'react'

/**
 * Render basic inline markdown (``*text*`` → ``<em>text</em>``) as a
 * React fragment. Used by the in-editor bibliography footer and the
 * share view's mirrored footer so journal names and other italicised
 * citation fragments render the same in both surfaces.
 */
export function renderMarkdownInline(text: string): ReactNode {
  const parts = text.split(/(\*[^*]+\*)/g)
  if (parts.length === 1) return text
  return parts.map((part, i) =>
    part.startsWith('*') && part.endsWith('*')
      ? <em key={i}>{part.slice(1, -1)}</em>
      : part,
  )
}
